import { useEffect, type RefObject } from 'react'

/**
 * Hook to detect clicks outside a referenced element.
 * Extracted from 4 duplicated patterns (DUP-1):
 * AccountSwitcherDropdown, ProfileButton, ExportMenu.
 *
 * @param ref - React ref to the container element
 * @param callback - Called when a click outside is detected
 * @param enabled - Only listen when true (default: true)
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled) return

    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [ref, callback, enabled])
}
